var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/bold/award"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M74.2083 22.875V25.9584L59.4583 17.4167C53.875 14.2084 46.0833 14.2084 40.5417 17.4167L25.7917 26V22.875C25.7917 13.5 30.9167 8.33337 40.2917 8.33337H59.7083C69.0833 8.33337 74.2083 13.5 74.2083 22.875Z",
    fill: "#2ABC05"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M74.3333 33.2083L73.75 32.9167L68.0833 29.6667L56.3333 22.875C52.75 20.7917 47.25 20.7917 43.6667 22.875L31.9167 29.625L26.25 32.9583L25.5 33.3333C18.2083 38.25 17.7083 39.1667 17.7083 47.0417V65.875C17.7083 73.75 18.2083 74.6667 25.6667 79.7083L43.6667 90.0833C45.4583 91.1667 47.7083 91.625 50 91.625C52.25 91.625 54.5417 91.125 56.3333 90.0833L74.5 79.5833C81.8333 74.6667 82.2917 73.7917 82.2917 65.875V47.0417C82.2917 39.1667 81.7917 38.25 74.3333 33.2083ZM61.625 56.25L59.0833 59.375C58.6667 59.8333 58.375 60.7083 58.4167 61.3333L58.6667 65.3333C58.8333 67.7917 57.0833 69.0417 54.7917 68.1667L51.0833 66.6667C50.5 66.4583 49.5417 66.4583 48.9583 66.6667L45.25 68.125C42.9583 69.0417 41.2083 67.75 41.375 65.2917L41.625 61.2917C41.6667 60.6667 41.375 59.7917 40.9583 59.3333L38.375 56.25C36.7917 54.375 37.5 52.2917 39.875 51.6667L43.75 50.6667C44.375 50.5 45.0833 49.9167 45.4167 49.4167L47.5833 46.0833C48.9167 44 51.0417 44 52.4167 46.0833L54.5833 49.4167C54.9167 49.9583 55.6667 50.5 56.25 50.6667L60.125 51.6667C62.5 52.2917 63.2083 54.375 61.625 56.25Z",
    fill: "#2ABC05"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.8e28e5e5c271c362b0a3245f844ba6b7.svg";
export { ForwardRef as ReactComponent };